module.exports = __webpack_public_path__ + "media/mosaics/Mosaic-Focus-1-a36fb6d8.png";